import { roundCoordForSpiderGroup } from './markerSpider.constants';

export function makeCoordKey(latitude: number, longitude: number): string {
  return `${roundCoordForSpiderGroup(latitude)},${roundCoordForSpiderGroup(longitude)}`;
}
